/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from "react-redux";
import { getFinanacesScrapingHistoryList } from "../../../../apis/finances/auth";
import { ControlTable } from '../../../../components/Table';
import { SCRAPING_STATE, SVC_CD_TYPE } from '../../../../constants/SCRAPING_DATA';
import useForm from '../../../../hooks/useForm';
import { cardName } from '../../../../utils/account-name';
import { dateToViewFormat } from '../../../../utils/date';
import { getParams } from '../../../../utils/params';
import PassivityScrapingModal from './PassivityScrapingModal';
import ScrapingHistoryDetail from './ScrapingHistoryDetail';

import { forEach, isEmpty, trim } from "lodash";

import store from "../../../../store";
import { SET_SCRAPING_RUNS } from "../../../../store/scraping/actionTypes";
import { toast } from "../../../../utils/toast";

const ScrapingHistoryTable = ({ scrapingData, orgCd, permission }) => {
  const { scrapingRuns } = useSelector((store) => ({
    scrapingRuns: store.ScrapingRuns,
  }));

  const maxCount = 10;
  const [reload, setReload] = useState(false);
  const [countReload, setCountReload] = useState(maxCount);
  const [isScraping, setIsScraping] = useState(false);

  const [timerValue, setTimerValue] = useState(0);
  const timerId = useRef(null);

  const [isOpen, setIsOpen] = useState(false);
  // 상세페이지
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [detailData, setDetailData] = useState({});


  useEffect(() => {
    if (timerValue === 1) {
      setTimerValue(0);
      if (reload === true && countReload > 0) {
        submit(form);
        setSubmit(submit);
      }

      if (countReload <= 0) {
        setIsScraping(false);
        handleRunScraping(orgCd, false);
      }
    }
  }, [timerValue]);

  useEffect(() => {
    if (scrapingData) {
      setReload(false);
      setCountReload(maxCount);

      submit(form);
      setSubmit(submit);
    }
  }, [scrapingData]);

  useEffect(() => {
    timerId.current = setInterval(() => {
      setTimerValue(1);
    }, 1000 * 5);

    return () => clearInterval(timerId.current);
  }, []);

  const reloadHandler = async () => {
    setReload(false);
    setCountReload(maxCount);

    submit(form);
    setSubmit(submit);
  };

  useEffect(() => {
    if (orgCd === "hometax") {
      setIsScraping(scrapingRuns.runHometax);
    } else if (orgCd === "cardsales") {
      setIsScraping(scrapingRuns.runCardSales);
    } else if (orgCd === "card") {
      setIsScraping(scrapingRuns.runCard);
    } else if (orgCd === "ccd") {
      setIsScraping(scrapingRuns.runCcd);
    } else if (orgCd === "pbk") {
      setIsScraping(scrapingRuns.runPbk);
    } else if (orgCd === "cbk") {
      setIsScraping(scrapingRuns.runCbk);
    }

  }, [scrapingRuns]);

  const handleRunScraping = (mode, value) => {
    if (mode === "hometax") {
      store.dispatch({
        type: SET_SCRAPING_RUNS,
        payload: {
          runHometax: value,
        }
      });
    } else if (mode === "cardsales") {
      store.dispatch({
        type: SET_SCRAPING_RUNS,
        payload: {
          runCardSales: value,
        }
      });
    } else if (mode === "card") {
      store.dispatch({
        type: SET_SCRAPING_RUNS,
        payload: {
          runCard: value,
        }
      });
    } else if (mode === "ccd") {
      store.dispatch({
        type: SET_SCRAPING_RUNS,
        payload: {
          runCcd: value,
        }
      });
    } else if (mode === "pbk") {
      store.dispatch({
        type: SET_SCRAPING_RUNS,
        payload: {
          runPbk: value,
        }
      });
    } else if (mode === "cbk") {
      store.dispatch({
        type: SET_SCRAPING_RUNS,
        payload: {
          runCbk: value,
        }
      });
    }
  };

  const [fields] = useState([
    { title: '스크래핑 날짜', key: 'scrapDate', type: 'date' },
    {
      title: '수집 기간', onValue: (value, fields, data) => {
        return `${dateToViewFormat(data.sDate)} ~ ${dateToViewFormat(data.eDate)}`;
      }
    },
    {
      title: '서비스',
      key: 'svcCd',
      onTranslator: {
        list: SVC_CD_TYPE
      }
    },
    {
      title: '상태',
      key: 'state',
      onTranslator: {
        list: SCRAPING_STATE
      }
    },
  ]);

  const {
    form,
    setSubmit,
    handleSubmit,
    // LIST 용
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      page: 0,
      limit: orgCd === "hometax" ? 6 : 3, // 10,
      order: [
        {
          idx: "desc"
        }
      ],
    },
  );

  const submit = (params) => {
    setIsLoading(true);
    getFinanacesScrapingHistoryList(scrapingData.idx, { ...getParams(params) })
      .then((res) => {
        let count = 0;
        if (orgCd === "hometax") {
          forEach(res.data.histories, data => {
            if (data.state === 9) {
              count = count + 1;
            }
          });
        } else {
          if (!isEmpty(res.data.histories) && (res.data.histories[0].state === 9)) {
            count = count + 1;
          }
        }

        if (count !== 0) {
          setReload(true);
          setCountReload(countReload - 1);
          handleRunScraping(orgCd, true);
        } else {
          setReload(false);
          setCountReload(maxCount);
          handleRunScraping(orgCd, false);
        }

        setList(res.data.histories);
        setTotal(res.data.total);
      })
      .catch(() => { })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const tableButton = [
    {
      label: '새로고침',
      color: 'green', //'gray-line',
      action: () => {
        submit(form);
        setSubmit(submit);
      }
    },
    {
      label: '수동 스크래핑',
      color: isScraping ? "gray-line" : "green",
      action: () => {
        if (isScraping === true) {
          toast.info("스크래핑중입니다. 완료후 시도하세요.");
          return;
        }
        setIsOpen(true);
      }
    }
  ];

  const handleRowClick = (data) => {
    setDetailData(data);
    setIsDetailOpen(true);
  };

  const getTitle = () => {
    let title = scrapingData.acctNm;

    if (scrapingData.memNm) {
      title = `${scrapingData.memNm}`;
    }
    if (scrapingData.acctNo) {
      if (!isEmpty(scrapingData.nickName) && trim(String(scrapingData.nickName)) !== "") {
        const nickName = "[" + trim(String(scrapingData.nickName)) + "]";
        title = `(${scrapingData.acctNo.substr(scrapingData.acctNo.length - 5)}) ${title} - ${nickName}`;
      } else {
        title = `(${scrapingData.acctNo.substr(scrapingData.acctNo.length - 5)}) ${title}`;
      }
    }
    if (scrapingData.cardNm) {
      if (!isEmpty(scrapingData.nickName) && trim(String(scrapingData.nickName)) !== "") {
        title = `${cardName(scrapingData.cardCompany, scrapingData.cardNo)} ${scrapingData.cardNm} - [${scrapingData.nickName}]`;
      } else {
        title = `${cardName(scrapingData.cardCompany, scrapingData.cardNo)} ${scrapingData.cardNm}`;
      }
    }

    return title;
  };
  return (
    <>
      <ControlTable
        isLoading={isLoading}
        fields={fields}
        list={list}
        title={getTitle()}
        buttons={permission.level > 1 ? tableButton : []}
        onSelect={handleRowClick}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        submit={handleSubmit}
      />
      {isOpen && (
        <PassivityScrapingModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          submit={submit}
          scrapingData={scrapingData}
          orgCd={orgCd}
          reload={reloadHandler}
        />
      )}
      {isDetailOpen && (
        <ScrapingHistoryDetail
          isOpen={isDetailOpen}
          setIsOpen={setIsDetailOpen}
          data={detailData}
        />
      )}
    </>
  );
};

export default ScrapingHistoryTable;